























































import { Component, Prop, Vue } from "vue-property-decorator";
import { Location } from "vue-router";
import { ROUTE_NAMES } from "../../router/routenames";
import DoKoHtmlDialog from "./DoKoHtmlDialog.vue";
import DoKoBtn from "../controls/DoKoBtn.vue";
import { Action } from "vuex-class";

import { api as userApi } from "../../store/modules/user";
import { SigninUserPayload } from "../../store/modules/user/types";

@Component({ components: { DoKoHtmlDialog, DoKoBtn } })
export default class DoKoSignin extends Vue {
  email = "";
  password = "";
  loading = false;
  error = "";

  signupRoute: Location = {
    name: ROUTE_NAMES.SIGNUP,
  };
  passwordResetRoute: Location = {
    name: ROUTE_NAMES.RESET_PASSWORD,
  };

  get valid() {
    return this.email.trim() !== "" && this.password.trim() !== "";
  }
  @Action(userApi.actions.signin, { namespace: userApi.namespace })
  signinUser!: (payload: SigninUserPayload) => Promise<any>;

  async sendLogin() {
    this.loading = true;
    try {
      console.log("signinUser");
      await this.signinUser({
        email: this.email.trim(),
        password: this.password.trim(),
      });
      this.$router.push({
        name: ROUTE_NAMES.LOBBY,
      });
    } catch (err) {
      console.error(err);
      this.error = err;
    }
    this.loading = false;
  }
}
